'use strict';

import '../frontoffice_app';

/** Import AjaxHandler class */
import AjaxHandler from '../../../shared/utility/ajax_handler/ajax_handler';

/**
 * @class RegistrationHandler
 */
class RegistrationHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._listenClearCheckMail();
        this._listenCheckMail();
    }

    /**
     * @private
     */
    _listenClearCheckMail ()
    {
        $('#user_registration_form_mail').on('focus', (e) =>
        {
            $('#user_registration_form_mail').parent().find('#mail-error').remove();
        });
    }

    /**
     * @private
     */
    _listenCheckMail ()
    {
        $('#user_registration_form_mail').on('blur', (e) =>
        {
            let data = {
                mail: $(e.target).val()
            };
            AjaxHandler.post('registration/check-mail', data).then((response) =>
            {
                if (response.validity)
                {
                    $('#user_registration_form_mail').parent().find('#mail-error').remove();
                } else {
                    let codeInput = $('#user_registration_form_mail');
                    codeInput.parent().find('#mail-error').remove();
                    codeInput.after('<span id="mail-error" style="color: red;">Ovaj email je već zauzet!</span>')
                }
            })
        });
    }
}

/** Start RegistrationHandler */
$(document).ready(() => { new RegistrationHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/registration.js